import React from 'react';
import { IconButton } from '@atlaskit/button/new';
// eslint-disable-next-line import/order
import CrossIcon from '@atlaskit/icon/glyph/cross';

import { type Appearance, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Inline, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';

type Props = {
	title: string;
	onClose: () => void;
	appearance?: Appearance;
	testId: string;
};
export const PriorityModalHeader = ({ title, onClose, appearance, testId }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<ModalHeader>
			<Inline alignBlock="center" xcss={ModalHeaderStyles}>
				<ModalTitle testId={testId} appearance={appearance}>
					{title}
				</ModalTitle>
				<IconButton
					appearance="subtle"
					icon={CrossIcon}
					label={formatMessage(messages.cancelButton)}
					onClick={onClose}
				/>
			</Inline>
		</ModalHeader>
	);
};

const ModalHeaderStyles = xcss({
	justifyContent: 'space-between',
	width: '100%',
});
